module.exports = __webpack_public_path__ + "img/project.e4ca80de.png";